import { icons } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type IconCatalogEntry = {
  name: string
  Icon: LucideIcon
}

export type IconCatalog = {
  entries: IconCatalogEntry[]
  byName: ReadonlyMap<string, LucideIcon>
}

const EXPORT_NAME_TOKEN = /\d+x\d+|\d[a-z]*|[A-Z][a-z]*/g

const NAMES_THE_TOKENIZER_CANNOT_DERIVE: Record<string, string> = {
  Clock10: 'clock-10',
  Clock11: 'clock-11',
  Clock12: 'clock-12'
}

const toLucideName = (exportName: string) =>
  NAMES_THE_TOKENIZER_CANNOT_DERIVE[exportName] ??
  (exportName.match(EXPORT_NAME_TOKEN) ?? []).join('-').toLowerCase()

let catalog: IconCatalog | null = null

export const getIconCatalog = (): IconCatalog => {
  if (!catalog) {
    const entries = Object.entries(icons)
      .map(([exportName, Icon]) => ({ name: toLucideName(exportName), Icon }))
      .sort((a, b) => a.name.localeCompare(b.name))

    catalog = {
      entries,
      byName: new Map(entries.map(({ name, Icon }) => [name, Icon]))
    }
  }

  return catalog
}
